
/**
 * Permet d'ouvrir un blob qui peut être très gros. Si le blob fait plus que 5Mo alors il est téléchargé.
 * Sinon il est juste ouvert dans une URL.
 * @param {*} nom
 * @param {*} url
 * @param {*} timeout 2 minutes par défaut
 * @returns
 *  */
export function ouvreBlob(nom, url, timeout=120000) {
    return response => {
        const blob = response.data;
        if(blob.size > 5000000) {
            const href = URL.createObjectURL(blob);
            const link = window.document.createElement("a");
            link.href = href;
            link.setAttribute("download",  nom);
            if (typeof link.download === "undefined") {
                link.setAttribute("target", "_blank");
            }
            link.click();

            // Fixes "webkit blob resource error 1"
            setTimeout(()=> {
                window.URL.revokeObjectURL(href);
            }, timeout);
        } else {
            window.open(url, "_blank");
        }
    };
}

export default class DocumentService{
    constructor(axios, snackbar) {
        this.axios = axios;
        this.snackbar = snackbar;
    }

    blob(url, params) {
          url = url.replaceAll(";", "");
        return this.axios
            .get(url, {
                responseType: "blob",
                params,
            })
            .catch(this.snackbar.catch())
            .then(response => response.data);
    }

    telechargeBlob(nom, url) {
          url = url.replaceAll(";", "");
        return this.axios
            .get(url, {
                responseType: "blob",
            })
            .catch(this.snackbar.catch())
            .then(ouvreBlob(nom, url));
    }

}
